module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVQ4T2NgGBygPfA/NvznohhePGoAPQx4IaiLF48agGzAkAYASitZpvCJMEgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BJ.png
// module id = 1092
// module chunks = 0